import { render } from "./orderPage.vue?vue&type=template&id=90279f04&scoped=true"
import script from "./orderPage.vue?vue&type=script&lang=js"
export * from "./orderPage.vue?vue&type=script&lang=js"

import "./orderPage.vue?vue&type=style&index=0&id=90279f04&scoped=true&lang=scss"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90279f04"]])

export default __exports__